
import { defineComponent } from 'vue';
import { useMainStore } from '@/store/mainStore';

export default defineComponent({
  props: {
    message: { type: String, default: '' },
  },
  setup() {
    const mainStore = useMainStore();
    return {
      mainStore,
    };
  },
});
